import "./app/config"; // window.config(“bare config”)를 다른 모듈보다 먼저 채운다
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./components/App";
import registerSW from "./registerSW";

registerSW();

const root = createRoot(document.querySelector("#root")!);
root.render(<App />);
